module.exports = global["m"] = require("-!./index.js");